// ChallengeArena.jsx — نسخهٔ نهایی AAA (با آیکون‌های SVG و زیست‌بوم‌های عمقدار)
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useExams, toNumber } from '../Exams/ExamContext.jsx';
import { useCoins } from '../../context/CoinContext.jsx';
import { useAuth } from '../../context/AuthContext.jsx';
import { needsField, getGrade, getFieldOptions, normalizeGradeId, normalizeFieldId } from '../../core/education/curriculum.js';
import './ChallengeArena.css';

/* ============================================================
   SVG SPRITE — دکوراسیون‌های غنی
   ============================================================ */
const DecoSprites = () => (
  <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
    <defs>
      <linearGradient id="g-pine" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#81C784" /><stop offset="55%" stopColor="#2E7D32" /><stop offset="100%" stopColor="#0D3B0D" />
      </linearGradient>
      <linearGradient id="g-round" x1="0.3" y1="0.2" x2="0.7" y2="0.9">
        <stop offset="0%" stopColor="#A5D6A7" /><stop offset="55%" stopColor="#43A047" /><stop offset="100%" stopColor="#1B5E20" />
      </linearGradient>
      <linearGradient id="g-autumn" x1="0.3" y1="0.2" x2="0.7" y2="0.9">
        <stop offset="0%" stopColor="#FFCC80" /><stop offset="50%" stopColor="#E64A19" /><stop offset="100%" stopColor="#8B2500" />
      </linearGradient>
      <linearGradient id="g-blossom" x1="0.3" y1="0.2" x2="0.7" y2="0.9">
        <stop offset="0%" stopColor="#FCE4EC" /><stop offset="50%" stopColor="#EC407A" /><stop offset="100%" stopColor="#880E4F" />
      </linearGradient>
      <linearGradient id="g-winter" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#FFFFFF" /><stop offset="70%" stopColor="#B3E5FC" /><stop offset="100%" stopColor="#4CAF50" />
      </linearGradient>
      <linearGradient id="g-trunk" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#3E2723" /><stop offset="50%" stopColor="#8D6E63" /><stop offset="100%" stopColor="#4E342E" />
      </linearGradient>
      <linearGradient id="g-palm" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#81C784" /><stop offset="100%" stopColor="#1B5E20" />
      </linearGradient>
      <linearGradient id="g-cloud" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="rgba(255,255,255,0.98)" /><stop offset="100%" stopColor="rgba(255,255,255,0.55)" />
      </linearGradient>
      <radialGradient id="g-sun" cx="35%" cy="30%" r="65%">
        <stop offset="0%" stopColor="#FFFFFF" /><stop offset="35%" stopColor="#FFF176" /><stop offset="75%" stopColor="#FFB300" /><stop offset="100%" stopColor="#E65100" />
      </radialGradient>
      <radialGradient id="g-moon" cx="35%" cy="30%" r="65%">
        <stop offset="0%" stopColor="#FFFFFF" /><stop offset="100%" stopColor="#90A4AE" />
      </radialGradient>

      <symbol id="d-pine" viewBox="0 0 40 60">
        <ellipse cx="20" cy="58" rx="12" ry="2.2" fill="rgba(0,0,0,0.42)" />
        <rect x="18" y="40" width="4" height="18" fill="url(#g-trunk)" rx="1" />
        <path d="M20 16 L38 48 L2 48 Z" fill="url(#g-pine)" />
        <path d="M20 8 L34 32 L6 32 Z" fill="url(#g-pine)" />
        <path d="M20 0 L30 20 L10 20 Z" fill="url(#g-pine)" />
        <path d="M20 2 L26 14 L20 14 Z" fill="#C8E6C9" opacity="0.55" />
        <path d="M20 10 L28 24 L20 24 Z" fill="#C8E6C9" opacity="0.42" />
        <path d="M20 18 L30 38 L20 38 Z" fill="#C8E6C9" opacity="0.32" />
      </symbol>
      <symbol id="d-round" viewBox="0 0 60 60">
        <ellipse cx="30" cy="58" rx="16" ry="2.5" fill="rgba(0,0,0,0.4)" />
        <rect x="27" y="42" width="6" height="16" fill="url(#g-trunk)" />
        <circle cx="30" cy="30" r="22" fill="url(#g-round)" />
        <circle cx="22" cy="24" r="14" fill="#4CAF50" opacity="0.85" />
        <circle cx="38" cy="26" r="13" fill="#4CAF50" opacity="0.85" />
        <circle cx="30" cy="20" r="12" fill="#66BB6A" />
        <circle cx="24" cy="18" r="6" fill="#A5D6A7" opacity="0.7" />
        <circle cx="36" cy="20" r="4" fill="#C8E6C9" opacity="0.5" />
      </symbol>
      <symbol id="d-autumn" viewBox="0 0 60 60">
        <ellipse cx="30" cy="58" rx="16" ry="2.5" fill="rgba(0,0,0,0.4)" />
        <rect x="27" y="42" width="6" height="16" fill="url(#g-trunk)" />
        <circle cx="30" cy="30" r="22" fill="url(#g-autumn)" />
        <circle cx="22" cy="24" r="14" fill="#F4511E" opacity="0.85" />
        <circle cx="38" cy="26" r="13" fill="#F4511E" opacity="0.85" />
        <circle cx="30" cy="20" r="12" fill="#FF7043" />
        <circle cx="24" cy="18" r="6" fill="#FFAB91" opacity="0.7" />
        <circle cx="36" cy="20" r="4" fill="#FFCCBC" opacity="0.6" />
      </symbol>
      <symbol id="d-winter" viewBox="0 0 40 60">
        <ellipse cx="20" cy="58" rx="11" ry="2.2" fill="rgba(0,0,0,0.3)" />
        <rect x="18" y="40" width="4" height="18" fill="url(#g-trunk)" />
        <path d="M20 16 L38 48 L2 48 Z" fill="url(#g-winter)" />
        <path d="M20 8 L34 32 L6 32 Z" fill="url(#g-winter)" />
        <path d="M20 0 L30 20 L10 20 Z" fill="url(#g-winter)" />
        <path d="M20 3 L26 14 L20 14 Z" fill="#FFFFFF" opacity="0.95" />
        <path d="M20 10 L28 22 L14 22 Z" fill="#FFFFFF" opacity="0.85" />
        <path d="M20 20 L32 34 L10 34 Z" fill="#FFFFFF" opacity="0.75" />
      </symbol>
      <symbol id="d-blossom" viewBox="0 0 60 60">
        <ellipse cx="30" cy="58" rx="16" ry="2.5" fill="rgba(0,0,0,0.35)" />
        <rect x="27" y="42" width="6" height="16" fill="url(#g-trunk)" />
        <circle cx="30" cy="30" r="22" fill="url(#g-blossom)" />
        <circle cx="22" cy="24" r="14" fill="#F06292" opacity="0.85" />
        <circle cx="38" cy="26" r="13" fill="#F06292" opacity="0.85" />
        <circle cx="30" cy="20" r="12" fill="#F48FB1" />
        <circle cx="24" cy="18" r="6" fill="#F8BBD0" opacity="0.85" />
        <circle cx="36" cy="20" r="4" fill="#FCE4EC" opacity="0.9" />
        <circle cx="20" cy="28" r="3" fill="#FFFFFF" opacity="0.7" />
      </symbol>
      <symbol id="d-palm" viewBox="0 0 50 60">
        <ellipse cx="25" cy="58" rx="12" ry="2.2" fill="rgba(0,0,0,0.35)" />
        <path d="M22 55 Q24 30 26 15 Q27 30 27 55 Z" fill="url(#g-trunk)" />
        <path d="M26 15 Q35 12 45 18 Q36 17 27 19 Z" fill="url(#g-palm)" />
        <path d="M26 15 Q17 12 5 20 Q17 17 25 19 Z" fill="url(#g-palm)" />
        <path d="M26 15 Q30 8 40 5 Q32 12 28 18 Z" fill="#66BB6A" />
        <path d="M26 15 Q22 8 12 6 Q20 12 24 18 Z" fill="#66BB6A" />
        <path d="M26 15 Q28 4 32 0 Q30 10 28 17 Z" fill="#A5D6A7" opacity="0.85" />
        <circle cx="26" cy="16" r="2" fill="#5D4037" />
      </symbol>
      <symbol id="d-bush" viewBox="0 0 40 30">
        <ellipse cx="20" cy="28" rx="14" ry="2.2" fill="rgba(0,0,0,0.3)" />
        <circle cx="12" cy="20" r="8" fill="#2E7D32" />
        <circle cx="20" cy="16" r="9" fill="url(#g-round)" />
        <circle cx="28" cy="20" r="8" fill="#2E7D32" />
        <circle cx="16" cy="16" r="5" fill="#66BB6A" opacity="0.85" />
        <circle cx="24" cy="15" r="4" fill="#A5D6A7" opacity="0.7" />
      </symbol>
      <symbol id="d-flower-red" viewBox="0 0 20 30">
        <path d="M10 30 Q9 20 10 12" stroke="#4CAF50" strokeWidth="1.5" fill="none" />
        <circle cx="6" cy="20" r="3" fill="#2E7D32" />
        {[0,72,144,216,288].map((a,i)=>(<circle key={i} cx={10+Math.cos(a*Math.PI/180)*4} cy={10+Math.sin(a*Math.PI/180)*4} r="3" fill={i%2?'#EF5350':'#E53935'} />))}
        <circle cx="10" cy="10" r="2.2" fill="#FFEB3B" />
      </symbol>
      <symbol id="d-flower-purple" viewBox="0 0 20 30">
        <path d="M10 30 Q9 20 10 12" stroke="#4CAF50" strokeWidth="1.5" fill="none" />
        <circle cx="6" cy="20" r="3" fill="#2E7D32" />
        {[0,72,144,216,288].map((a,i)=>(<circle key={i} cx={10+Math.cos(a*Math.PI/180)*4} cy={10+Math.sin(a*Math.PI/180)*4} r="3" fill={i%2?'#AB47BC':'#8E24AA'} />))}
        <circle cx="10" cy="10" r="2.2" fill="#FFEB3B" />
      </symbol>
      <symbol id="d-flower-yellow" viewBox="0 0 20 30">
        <path d="M10 30 Q9 20 10 12" stroke="#4CAF50" strokeWidth="1.5" fill="none" />
        <circle cx="6" cy="20" r="3" fill="#2E7D32" />
        {[0,72,144,216,288].map((a,i)=>(<circle key={i} cx={10+Math.cos(a*Math.PI/180)*4} cy={10+Math.sin(a*Math.PI/180)*4} r="3" fill={i%2?'#FFD54F':'#FFB300'} />))}
        <circle cx="10" cy="10" r="2.2" fill="#FF6F00" />
      </symbol>
      <symbol id="d-sunflower" viewBox="0 0 30 50">
        <path d="M15 50 Q14 35 15 22" stroke="#558B2F" strokeWidth="2" fill="none" />
        <ellipse cx="8" cy="35" rx="5" ry="3" fill="#7CB342" transform="rotate(-30 8 35)" />
        <ellipse cx="22" cy="40" rx="5" ry="3" fill="#7CB342" transform="rotate(30 22 40)" />
        <g transform="translate(15 15)">
          {[0,45,90,135,180,225,270,315].map((a,i)=>(<circle key={i} cx={Math.cos(a*Math.PI/180)*7} cy={Math.sin(a*Math.PI/180)*7} r="4" fill={i%2?'#FFD54F':'#FFC107'} />))}
          <circle cx="0" cy="0" r="5.5" fill="#5D4037" />
          <circle cx="-1.5" cy="-1.5" r="2" fill="#3E2723" opacity="0.6" />
        </g>
      </symbol>
      <symbol id="d-rock" viewBox="0 0 30 22">
        <ellipse cx="15" cy="20" rx="12" ry="2" fill="rgba(0,0,0,0.35)" />
        <path d="M4 18 Q2 12 8 6 Q14 2 22 8 Q28 14 24 18 Z" fill="#455A64" />
        <path d="M8 16 Q6 11 11 7 Q16 4 20 9 Q24 14 22 17 Z" fill="#78909C" />
        <path d="M10 12 Q12 8 15 8 Q13 11 11 13 Z" fill="#CFD8DC" opacity="0.8" />
        <circle cx="20" cy="13" r="1.5" fill="#37474F" opacity="0.5" />
      </symbol>
      <symbol id="d-mushroom" viewBox="0 0 20 22">
        <ellipse cx="10" cy="20" rx="7" ry="1.2" fill="rgba(0,0,0,0.3)" />
        <path d="M8 18 Q7 12 8 8 L12 8 Q13 12 12 18 Z" fill="#F5F5F0" />
        <path d="M2 10 Q4 2 10 2 Q16 2 18 10 Z" fill="#D32F2F" />
        <circle cx="6" cy="6" r="1.3" fill="#FFEBEE" /><circle cx="12" cy="5" r="1.2" fill="#FFEBEE" />
        <circle cx="14" cy="8" r="1" fill="#FFEBEE" /><circle cx="8" cy="8.5" r="0.8" fill="#FFEBEE" />
      </symbol>
      <symbol id="d-grass" viewBox="0 0 24 16">
        <path d="M3 16 Q2 8 6 2 Q6 9 5 16 Z" fill="#558B2F" />
        <path d="M8 16 Q7 6 10 0 Q10 8 9.5 16 Z" fill="#7CB342" />
        <path d="M13 16 Q13 9 16 3 Q15 10 14.5 16 Z" fill="#558B2F" />
        <path d="M18 16 Q18 10 21 5 Q20 10 19 16 Z" fill="#9CCC65" opacity="0.9" />
      </symbol>
      <symbol id="d-grass-tall" viewBox="0 0 28 22">
        <path d="M4 22 Q3 12 8 4 Q8 12 7 22 Z" fill="#33691E" />
        <path d="M10 22 Q9 10 13 0 Q13 11 12 22 Z" fill="#558B2F" />
        <path d="M16 22 Q16 12 20 2 Q19 12 18 22 Z" fill="#33691E" />
        <path d="M22 22 Q22 14 25 6 Q24 14 23 22 Z" fill="#7CB342" opacity="0.95" />
      </symbol>
      <symbol id="d-butterfly" viewBox="0 0 20 16">
        <path d="M10 8 Q4 2 2 6 Q2 10 10 8 Z" fill="#F06292" opacity="0.95" />
        <path d="M10 8 Q4 14 2 10 Q2 6 10 8 Z" fill="#EC407A" opacity="0.95" />
        <path d="M10 8 Q16 2 18 6 Q18 10 10 8 Z" fill="#F06292" opacity="0.95" />
        <path d="M10 8 Q16 14 18 10 Q18 6 10 8 Z" fill="#EC407A" opacity="0.95" />
        <circle cx="10" cy="8" r="1.2" fill="#3E2723" />
      </symbol>
      <symbol id="d-bird" viewBox="0 0 24 8">
        <path d="M2 6 Q6 2 10 5 Q12 3 14 5 Q18 2 22 6" stroke="#37474F" strokeWidth="1.4" fill="none" strokeLinecap="round" />
      </symbol>
      <symbol id="d-cloud" viewBox="0 0 100 40">
        <ellipse cx="20" cy="28" rx="18" ry="10" fill="url(#g-cloud)" />
        <ellipse cx="45" cy="22" rx="22" ry="14" fill="url(#g-cloud)" />
        <ellipse cx="72" cy="26" rx="20" ry="11" fill="url(#g-cloud)" />
        <ellipse cx="35" cy="30" rx="14" ry="7" fill="rgba(255,255,255,0.7)" />
        <ellipse cx="58" cy="30" rx="12" ry="6" fill="rgba(255,255,255,0.7)" />
      </symbol>
      <symbol id="d-sun" viewBox="0 0 80 80">
        {[0,45,90,135,180,225,270,315].map((a)=>(<line key={a} x1="40" y1="40" x2="40" y2="4" stroke="#FFF176" strokeWidth="2.4" strokeLinecap="round" transform={`rotate(${a} 40 40)`} opacity="0.7" />))}
        <circle cx="40" cy="40" r="18" fill="url(#g-sun)" />
        <circle cx="35" cy="35" r="6" fill="rgba(255,255,255,0.5)" />
      </symbol>
      <symbol id="d-moon" viewBox="0 0 80 80">
        <circle cx="40" cy="40" r="18" fill="url(#g-moon)" />
        <circle cx="34" cy="36" r="4" fill="rgba(255,255,255,0.4)" />
        <circle cx="46" cy="44" r="3" fill="rgba(120,144,156,0.5)" />
        <circle cx="44" cy="32" r="2" fill="rgba(120,144,156,0.4)" />
      </symbol>
    </defs>
  </svg>
);

/* ============================================================
   SVG SPRITE — آیکون‌های اختصاصی مرحله (جایگزین ایموجی)
   ============================================================ */
const StageIconSprites = () => (
  <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
    <defs>
      <linearGradient id="ig-gold" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#FFE082" /><stop offset="50%" stopColor="#FFB300" /><stop offset="100%" stopColor="#E65100" />
      </linearGradient>
      <linearGradient id="ig-purple" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#E1BEE7" /><stop offset="50%" stopColor="#8E24AA" /><stop offset="100%" stopColor="#4A148C" />
      </linearGradient>
      <linearGradient id="ig-blue" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#B3E5FC" /><stop offset="50%" stopColor="#039BE5" /><stop offset="100%" stopColor="#01579B" />
      </linearGradient>
      <linearGradient id="ig-red" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#FF8A80" /><stop offset="50%" stopColor="#E53935" /><stop offset="100%" stopColor="#7F0000" />
      </linearGradient>
      <linearGradient id="ig-green" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#C5E1A5" /><stop offset="50%" stopColor="#43A047" /><stop offset="100%" stopColor="#1B5E20" />
      </linearGradient>
      <linearGradient id="ig-silver" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#FFFFFF" /><stop offset="50%" stopColor="#B0BEC5" /><stop offset="100%" stopColor="#546E7A" />
      </linearGradient>
      <linearGradient id="ig-brown" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#D7CCC8" /><stop offset="50%" stopColor="#8D6E63" /><stop offset="100%" stopColor="#3E2723" />
      </linearGradient>
      <radialGradient id="ig-orb" cx="35%" cy="30%" r="65%">
        <stop offset="0%" stopColor="#FFFFFF" /><stop offset="30%" stopColor="#B39DDB" /><stop offset="70%" stopColor="#5E35B1" /><stop offset="100%" stopColor="#1A0033" />
      </radialGradient>
      <radialGradient id="ig-gem" cx="35%" cy="30%" r="65%">
        <stop offset="0%" stopColor="#FFFFFF" /><stop offset="40%" stopColor="#80DEEA" /><stop offset="80%" stopColor="#00838F" /><stop offset="100%" stopColor="#00363A" />
      </radialGradient>
    </defs>

    <symbol id="i-flag" viewBox="0 0 48 48">
      <rect x="21" y="7" width="3.5" height="34" rx="1.75" fill="url(#ig-brown)" />
      <circle cx="22.75" cy="7" r="3" fill="url(#ig-gold)" />
      <circle cx="21.75" cy="6" r="1.2" fill="rgba(255,255,255,0.8)" />
      <path d="M24.5 10 Q31 8 39 11 Q43 13 39 17 Q35 21 28 20 Q25 20 24.5 19 Z" fill="url(#ig-red)" />
      <path d="M24.5 10 Q31 8 39 11" stroke="rgba(255,255,255,0.6)" strokeWidth="1" fill="none" />
      <path d="M26 13 Q30 12 34 13" stroke="rgba(255,255,255,0.35)" strokeWidth="0.8" fill="none" />
    </symbol>

    <symbol id="i-compass" viewBox="0 0 48 48">
      <circle cx="24" cy="24" r="17" fill="#37474F" />
      <circle cx="24" cy="24" r="17" fill="none" stroke="url(#ig-gold)" strokeWidth="2" />
      <circle cx="24" cy="24" r="13" fill="#455A64" />
      <circle cx="24" cy="24" r="13" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1" />
      <path d="M24 11 L27 22 L24 20 L21 22 Z" fill="#EF5350" />
      <path d="M24 37 L21 26 L24 28 L27 26 Z" fill="#ECEFF1" />
      <path d="M11 24 L22 21 L20 24 L22 27 Z" fill="#ECEFF1" />
      <path d="M37 24 L26 27 L28 24 L26 21 Z" fill="#ECEFF1" />
      <circle cx="24" cy="24" r="2.8" fill="url(#ig-gold)" />
      <circle cx="23" cy="23" r="1" fill="rgba(255,255,255,0.8)" />
    </symbol>

    <symbol id="i-scroll" viewBox="0 0 48 48">
      <rect x="10" y="11" width="28" height="26" rx="2" fill="#F5E6C8" />
      <path d="M10 13 Q10 11 12 11 L36 11 Q38 11 38 13 L38 15 Q38 17 36 17 L12 17 Q10 17 10 15 Z" fill="#D7B98E" />
      <path d="M10 33 Q10 35 12 35 L36 35 Q38 35 38 33 L38 31 Q38 29 36 29 L12 29 Q10 29 10 31 Z" fill="#D7B98E" />
      <ellipse cx="11" cy="14" rx="2" ry="3" fill="url(#ig-brown)" />
      <ellipse cx="37" cy="32" rx="2" ry="3" fill="url(#ig-brown)" />
      <line x1="16" y1="21" x2="32" y2="21" stroke="#8D6E63" strokeWidth="1" opacity="0.6" />
      <line x1="16" y1="24.5" x2="30" y2="24.5" stroke="#8D6E63" strokeWidth="1" opacity="0.6" />
      <line x1="16" y1="28" x2="28" y2="28" stroke="#8D6E63" strokeWidth="1" opacity="0.6" />
      <circle cx="33" cy="24" r="3.2" fill="url(#ig-red)" />
      <circle cx="32" cy="23" r="1.2" fill="rgba(255,255,255,0.6)" />
    </symbol>

    <symbol id="i-map" viewBox="0 0 48 48">
      <path d="M6 14 L17 10 L31 14 L42 10 L42 36 L31 40 L17 36 L6 40 Z" fill="#F5E6C8" />
      <path d="M17 10 L17 36" stroke="#C9A876" strokeWidth="1" />
      <path d="M31 14 L31 40" stroke="#C9A876" strokeWidth="1" />
      <path d="M6 14 L17 10 L31 14 L42 10" stroke="#A1887F" strokeWidth="1.2" fill="none" />
      <path d="M6 40 L17 36 L31 40 L42 36" stroke="#A1887F" strokeWidth="1.2" fill="none" />
      <path d="M12 30 Q17 24 22 28 Q28 32 32 24 Q35 20 38 22" stroke="#EF5350" strokeWidth="1.5" fill="none" strokeDasharray="3 2.5" strokeLinecap="round" />
      <path d="M34 20 L38 24 M38 20 L34 24" stroke="#E53935" strokeWidth="2" strokeLinecap="round" />
      <circle cx="12" cy="18" r="3" fill="#455A64" />
      <path d="M12 15.5 L13 18 L12 17.5 L11 18 Z" fill="#EF5350" />
      <path d="M12 20.5 L11 18 L12 18.5 L13 18 Z" fill="#ECEFF1" />
    </symbol>

    <symbol id="i-potion" viewBox="0 0 48 48">
      <path d="M20 8 L28 8 L28 16 Q36 20 36 30 Q36 42 24 42 Q12 42 12 30 Q12 20 20 16 Z" fill="rgba(200,230,201,0.35)" stroke="rgba(255,255,255,0.3)" strokeWidth="1" />
      <path d="M14 30 Q14 38 24 38 Q34 38 34 30 Q34 24 30 20 L18 20 Q14 24 14 30 Z" fill="url(#ig-green)" />
      <path d="M16 28 Q17 34 22 35" stroke="rgba(255,255,255,0.55)" strokeWidth="1.2" fill="none" strokeLinecap="round" />
      <rect x="19" y="5" width="10" height="4" rx="1" fill="url(#ig-brown)" />
      <ellipse cx="24" cy="5" rx="5" ry="1.5" fill="#A1887F" />
      <circle cx="20" cy="28" r="1.5" fill="rgba(255,255,255,0.6)" />
      <circle cx="28" cy="32" r="1" fill="rgba(255,255,255,0.5)" />
      <circle cx="26" cy="25" r="0.8" fill="rgba(255,255,255,0.5)" />
    </symbol>

    <symbol id="i-sword" viewBox="0 0 48 48">
      <path d="M24 4 L28 34 L24 36 L20 34 Z" fill="url(#ig-silver)" />
      <path d="M24 4 L26 34 L24 36 Z" fill="rgba(255,255,255,0.4)" />
      <path d="M23 10 L24 30" stroke="rgba(255,255,255,0.7)" strokeWidth="0.8" />
      <rect x="16" y="34" width="16" height="3" rx="1.5" fill="url(#ig-gold)" />
      <rect x="22" y="37" width="4" height="8" rx="1.5" fill="url(#ig-brown)" />
      <circle cx="24" cy="45" r="2.5" fill="url(#ig-gold)" />
      <circle cx="23.2" cy="44.2" r="0.8" fill="rgba(255,255,255,0.8)" />
    </symbol>

    <symbol id="i-shield" viewBox="0 0 48 48">
      <path d="M24 5 L40 10 L40 25 Q40 37 24 43 Q8 37 8 25 L8 10 Z" fill="url(#ig-blue)" />
      <path d="M24 5 L40 10 L40 25 Q40 37 24 43 Z" fill="rgba(0,0,0,0.12)" />
      <path d="M24 9 L36 13 L36 24 Q36 33 24 38 Q12 33 12 24 L12 13 Z" fill="none" stroke="url(#ig-gold)" strokeWidth="1.8" />
      <rect x="22" y="14" width="4" height="22" rx="1" fill="url(#ig-gold)" />
      <rect x="14" y="22" width="20" height="4" rx="1" fill="url(#ig-gold)" />
      <path d="M15 13 Q14 18 16 24" stroke="rgba(255,255,255,0.35)" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    </symbol>

    <symbol id="i-orb" viewBox="0 0 48 48">
      <ellipse cx="24" cy="42" rx="12" ry="3" fill="rgba(80,40,140,0.35)" />
      <circle cx="24" cy="24" r="16" fill="url(#ig-orb)" />
      <ellipse cx="19" cy="18" rx="5" ry="3.5" fill="rgba(255,255,255,0.55)" transform="rotate(-30 19 18)" />
      <ellipse cx="31" cy="34" rx="4" ry="2" fill="rgba(255,255,255,0.15)" transform="rotate(-30 31 34)" />
      <circle cx="28" cy="14" r="1.3" fill="rgba(255,255,255,0.7)" />
      <path d="M35 20 L36 22 L38 23 L36 24 L35 26 L34 24 L32 23 L34 22 Z" fill="#FFFFFF" opacity="0.8" />
      <path d="M13 28 L13.5 29.5 L15 30 L13.5 30.5 L13 32 L12.5 30.5 L11 30 L12.5 29.5 Z" fill="#FFFFFF" opacity="0.6" />
    </symbol>

    <symbol id="i-gem" viewBox="0 0 48 48">
      <path d="M14 12 L34 12 L42 22 L24 42 L6 22 Z" fill="url(#ig-gem)" />
      <path d="M14 12 L24 22 L34 12" fill="rgba(255,255,255,0.25)" />
      <path d="M6 22 L24 22 L42 22" stroke="rgba(255,255,255,0.4)" strokeWidth="1" />
      <path d="M24 22 L24 42" stroke="rgba(0,0,0,0.2)" strokeWidth="1" />
      <path d="M14 12 L6 22 M34 12 L42 22" stroke="rgba(0,0,0,0.15)" strokeWidth="1" />
      <path d="M16 14 L22 14 L24 20 Z" fill="rgba(255,255,255,0.5)" />
      <path d="M10 23 L15 23 L18 27 Z" fill="rgba(255,255,255,0.2)" />
    </symbol>

    <symbol id="i-alchemy" viewBox="0 0 48 48">
      <path d="M18 10 L30 10 L30 18 L38 34 Q40 42 32 42 L16 42 Q8 42 10 34 L18 18 Z" fill="rgba(225,190,231,0.35)" stroke="rgba(255,255,255,0.3)" strokeWidth="1" />
      <path d="M13 32 Q13 39 22 39 L26 39 Q35 39 35 32 Q35 28 32 24 L16 24 Q13 28 13 32 Z" fill="url(#ig-purple)" />
      <path d="M16 30 Q17 35 21 36" stroke="rgba(255,255,255,0.55)" strokeWidth="1.2" fill="none" strokeLinecap="round" />
      <rect x="17" y="7" width="14" height="4" rx="1" fill="url(#ig-brown)" />
      <ellipse cx="24" cy="7" rx="7" ry="1.8" fill="#A1887F" />
      <circle cx="20" cy="28" r="1.5" fill="rgba(255,255,255,0.55)" />
      <circle cx="27" cy="31" r="1" fill="rgba(255,255,255,0.5)" />
      <circle cx="30" cy="28" r="0.7" fill="rgba(255,255,255,0.4)" />
    </symbol>

    <symbol id="i-temple" viewBox="0 0 48 48">
      <path d="M6 16 L24 5 L42 16 Z" fill="url(#ig-silver)" />
      <path d="M6 16 L42 16 L42 19 L6 19 Z" fill="#90A4AE" />
      <rect x="9" y="19" width="3.5" height="20" fill="#ECEFF1" />
      <rect x="16" y="19" width="3.5" height="20" fill="#ECEFF1" />
      <rect x="28.5" y="19" width="3.5" height="20" fill="#ECEFF1" />
      <rect x="35.5" y="19" width="3.5" height="20" fill="#ECEFF1" />
      <rect x="9" y="19" width="1.2" height="20" fill="rgba(0,0,0,0.15)" />
      <rect x="16" y="19" width="1.2" height="20" fill="rgba(0,0,0,0.15)" />
      <rect x="28.5" y="19" width="1.2" height="20" fill="rgba(0,0,0,0.15)" />
      <rect x="35.5" y="19" width="1.2" height="20" fill="rgba(0,0,0,0.15)" />
      <rect x="6" y="39" width="36" height="3" fill="#B0BEC5" />
      <rect x="6" y="42" width="36" height="1.5" fill="#78909C" />
    </symbol>

    <symbol id="i-bridge" viewBox="0 0 48 48">
      <path d="M4 30 Q24 12 44 30" stroke="url(#ig-brown)" strokeWidth="3" fill="none" strokeLinecap="round" />
      <path d="M4 30 L4 36 L44 36 L44 30" fill="none" />
      <rect x="4" y="28" width="40" height="4" fill="url(#ig-brown)" />
      <rect x="4" y="32" width="40" height="2" fill="rgba(0,0,0,0.2)" />
      <line x1="12" y1="30" x2="12" y2="36" stroke="rgba(0,0,0,0.25)" strokeWidth="1" />
      <line x1="20" y1="27" x2="20" y2="36" stroke="rgba(0,0,0,0.25)" strokeWidth="1" />
      <line x1="28" y1="27" x2="28" y2="36" stroke="rgba(0,0,0,0.25)" strokeWidth="1" />
      <line x1="36" y1="30" x2="36" y2="36" stroke="rgba(0,0,0,0.25)" strokeWidth="1" />
      <path d="M4 40 Q10 38 16 40 Q22 42 28 40 Q34 38 40 40 Q44 41 44 40" stroke="#4FC3F7" strokeWidth="1.5" fill="none" opacity="0.7" />
      <path d="M6 43 Q12 41 18 43 Q24 45 30 43 Q36 41 42 43" stroke="#4FC3F7" strokeWidth="1.2" fill="none" opacity="0.5" />
    </symbol>

    <symbol id="i-tower" viewBox="0 0 48 48">
      <rect x="17" y="16" width="14" height="28" fill="url(#ig-silver)" />
      <rect x="17" y="16" width="4" height="28" fill="rgba(0,0,0,0.12)" />
      <rect x="15" y="12" width="4" height="5" fill="#90A4AE" />
      <rect x="22" y="12" width="4" height="5" fill="#90A4AE" />
      <rect x="29" y="12" width="4" height="5" fill="#90A4AE" />
      <rect x="15" y="17" width="18" height="2" fill="#78909C" />
      <path d="M22 26 Q24 23 26 26 L26 32 L22 32 Z" fill="#37474F" />
      <path d="M22 26 Q24 23 26 26" stroke="#90A4AE" strokeWidth="1" fill="none" />
      <line x1="24" y1="12" x2="24" y2="2" stroke="#5D4037" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M24 3 Q28 2 31 4 L24 7 Z" fill="url(#ig-red)" />
    </symbol>

    <symbol id="i-trophy" viewBox="0 0 48 48">
      <path d="M14 8 L34 8 L34 22 Q34 32 24 34 Q14 32 14 22 Z" fill="url(#ig-gold)" />
      <path d="M14 10 Q8 10 8 18 Q8 24 14 24" stroke="url(#ig-gold)" strokeWidth="3" fill="none" strokeLinecap="round" />
      <path d="M34 10 Q40 10 40 18 Q40 24 34 24" stroke="url(#ig-gold)" strokeWidth="3" fill="none" strokeLinecap="round" />
      <path d="M14 8 L34 8" stroke="rgba(255,255,255,0.5)" strokeWidth="1" />
      <path d="M18 12 Q17 18 19 24" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" fill="none" strokeLinecap="round" />
      <rect x="21" y="34" width="6" height="5" fill="#B45309" />
      <rect x="16" y="39" width="16" height="4" rx="1" fill="url(#ig-gold)" />
      <rect x="16" y="42" width="16" height="1.5" fill="rgba(0,0,0,0.2)" />
      <path d="M24 15 L25.5 19 L30 19 L26.5 21.5 L28 26 L24 23 L20 26 L21.5 21.5 L18 19 L22.5 19 Z" fill="rgba(255,255,255,0.7)" />
    </symbol>

    <symbol id="i-medal" viewBox="0 0 48 48">
      <path d="M16 4 L20 4 L24 20 L20 22 Z" fill="url(#ig-blue)" />
      <path d="M32 4 L28 4 L24 20 L28 22 Z" fill="url(#ig-red)" />
      <path d="M16 4 L20 4 L24 20" fill="rgba(255,255,255,0.2)" />
      <circle cx="24" cy="30" r="14" fill="url(#ig-gold)" />
      <circle cx="24" cy="30" r="11" fill="none" stroke="rgba(255,255,255,0.35)" strokeWidth="1" />
      <path d="M24 22 L26.5 28 L33 28 L28 32 L30 38 L24 34.5 L18 38 L20 32 L15 28 L21.5 28 Z" fill="#FFFFFF" opacity="0.85" />
      <circle cx="20" cy="26" r="1.5" fill="rgba(255,255,255,0.7)" />
    </symbol>

    <symbol id="i-castle" viewBox="0 0 48 48">
      <rect x="12" y="22" width="24" height="22" fill="#C9A876" />
      <rect x="12" y="22" width="24" height="4" fill="#8D6E63" />
      <rect x="10" y="16" width="8" height="28" fill="url(#ig-brown)" />
      <rect x="30" y="16" width="8" height="28" fill="url(#ig-brown)" />
      <rect x="9" y="12" width="3" height="5" fill="#8D6E63" />
      <rect x="14" y="12" width="3" height="5" fill="#8D6E63" />
      <rect x="31" y="12" width="3" height="5" fill="#8D6E63" />
      <rect x="36" y="12" width="3" height="5" fill="#8D6E63" />
      <rect x="20" y="12" width="8" height="10" fill="#A1887F" />
      <rect x="19" y="8" width="3" height="5" fill="#8D6E63" />
      <rect x="26" y="8" width="3" height="5" fill="#8D6E63" />
      <rect x="19" y="13" width="10" height="2" fill="#8D6E63" />
      <rect x="12" y="24" width="3" height="5" rx="1.5" fill="#3E2723" />
      <rect x="33" y="24" width="3" height="5" rx="1.5" fill="#3E2723" />
      <rect x="22" y="28" width="4" height="6" rx="2" fill="#3E2723" />
      <path d="M21 44 L21 38 Q24 35 27 38 L27 44 Z" fill="#3E2723" />
      <line x1="24" y1="8" x2="24" y2="0" stroke="#3E2723" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M24 1 Q27 0 29 2 L24 4 Z" fill="url(#ig-red)" />
    </symbol>
  </svg>
);

/* ============================================================ */
/* CONSTANTS */
/* ============================================================ */
const PAD_TOP = 90;
const PAD_BOTTOM = 100;
const BIOME_SIZE = 20;

// آیکون‌ها از ایموجی به شناسه‌های SVG تغییر یافتند
const REGULAR_ICONS = [
  'i-flag', 'i-compass', 'i-scroll', 'i-map', 'i-potion',
  'i-sword', 'i-shield', 'i-orb', 'i-gem', 'i-alchemy',
  'i-temple', 'i-bridge', 'i-tower', 'i-trophy', 'i-medal',
];

/* ۸ زیست‌بوم غنی — با کوه‌های افق، لکه‌های رنگی و بافت */
const BIOMES = [
  {
    id: 'meadow', name: 'دشت بهاری',
    skyTop: '#87CEEB', skyMid: '#B5E8F5', skyBottom: '#EAF9D8',
    groundTop: '#7CB342', groundMid: '#558B2F', groundBottom: '#1B5E20',
    trees: ['d-round', 'd-round', 'd-pine', 'd-bush'],
    flowers: ['d-flower-red', 'd-flower-yellow', 'd-flower-purple', 'd-sunflower'],
    rocks: ['d-rock'], grass: 'd-grass',
    celestial: 'd-sun', cloudColor: 'rgba(255,255,255,0.9)',
    particle: { type: 'pollen', color: '#FFF59D' },
    hillsFar: '#9CCC65', hillsNear: '#7CB342',
    patchColors: ['rgba(180,220,120,0.30)', 'rgba(40,80,20,0.18)', 'rgba(220,240,180,0.22)'],
  },
  {
    id: 'forest', name: 'جنگل تابستان',
    skyTop: '#81C784', skyMid: '#43A047', skyBottom: '#2E7D32',
    groundTop: '#388E3C', groundMid: '#1B5E20', groundBottom: '#0D3B0D',
    trees: ['d-pine', 'd-pine', 'd-round', 'd-pine'],
    flowers: ['d-flower-red', 'd-flower-yellow'],
    rocks: ['d-rock', 'd-mushroom'], grass: 'd-grass-tall',
    celestial: 'd-sun', cloudColor: 'rgba(255,255,255,0.65)',
    particle: { type: 'leaf', color: '#66BB6A' },
    hillsFar: '#4CAF50', hillsNear: '#2E7D32',
    patchColors: ['rgba(100,160,80,0.28)', 'rgba(0,40,0,0.20)', 'rgba(160,200,120,0.18)'],
  },
  {
    id: 'autumn', name: 'پاییز طلایی',
    skyTop: '#FFB74D', skyMid: '#FF8A65', skyBottom: '#E64A19',
    groundTop: '#BF360C', groundMid: '#8B2500', groundBottom: '#3E1F00',
    trees: ['d-autumn', 'd-autumn', 'd-pine', 'd-bush'],
    flowers: ['d-flower-yellow', 'd-flower-red'],
    rocks: ['d-rock', 'd-mushroom'], grass: 'd-grass',
    celestial: 'd-sun', cloudColor: 'rgba(255,220,180,0.85)',
    particle: { type: 'leaf', color: '#FF6F00' },
    hillsFar: '#E64A19', hillsNear: '#BF360C',
    patchColors: ['rgba(255,150,80,0.30)', 'rgba(80,20,0,0.18)', 'rgba(255,200,120,0.20)'],
  },
  {
    id: 'winter', name: 'زمستان',
    skyTop: '#B3E5FC', skyMid: '#E1F5FE', skyBottom: '#F5FAFC',
    groundTop: '#ECEFF1', groundMid: '#B0BEC5', groundBottom: '#607D8B',
    trees: ['d-winter', 'd-winter', 'd-winter'],
    flowers: [], rocks: ['d-rock'], grass: 'd-grass',
    celestial: 'd-sun', cloudColor: 'rgba(255,255,255,0.95)',
    particle: { type: 'snow', color: '#FFFFFF' },
    hillsFar: '#CFD8DC', hillsNear: '#90A4AE',
    patchColors: ['rgba(255,255,255,0.35)', 'rgba(120,150,180,0.18)', 'rgba(220,235,245,0.25)'],
  },
  {
    id: 'blossom', name: 'دشت شکوفه',
    skyTop: '#F8BBD0', skyMid: '#F48FB1', skyBottom: '#FCE4EC',
    groundTop: '#EC407A', groundMid: '#AD1457', groundBottom: '#6A0E3F',
    trees: ['d-blossom', 'd-blossom', 'd-round', 'd-bush'],
    flowers: ['d-flower-purple', 'd-flower-red', 'd-sunflower'],
    rocks: ['d-rock'], grass: 'd-grass',
    celestial: 'd-sun', cloudColor: 'rgba(255,240,250,0.9)',
    particle: { type: 'petal', color: '#F8BBD0' },
    hillsFar: '#F48FB1', hillsNear: '#EC407A',
    patchColors: ['rgba(255,200,220,0.32)', 'rgba(120,20,60,0.18)', 'rgba(255,230,240,0.22)'],
  },
  {
    id: 'tropic', name: 'ساحل گرمسیری',
    skyTop: '#4FC3F7', skyMid: '#81D4FA', skyBottom: '#B3E5FC',
    groundTop: '#FFE082', groundMid: '#F9A825', groundBottom: '#BF8F00',
    trees: ['d-palm', 'd-palm', 'd-palm'],
    flowers: ['d-flower-red', 'd-flower-yellow'],
    rocks: ['d-rock'], grass: 'd-grass-tall',
    celestial: 'd-sun', cloudColor: 'rgba(255,255,255,0.85)',
    particle: { type: 'bubble', color: '#B3E5FC' },
    hillsFar: '#FFD54F', hillsNear: '#F9A825',
    patchColors: ['rgba(255,240,160,0.32)', 'rgba(140,100,0,0.18)', 'rgba(255,255,220,0.22)'],
  },
  {
    id: 'desert', name: 'کویر طلایی',
    skyTop: '#FF8A65', skyMid: '#FFB74D', skyBottom: '#FFE0B2',
    groundTop: '#FFB74D', groundMid: '#FF9800', groundBottom: '#8B5A00',
    trees: ['d-palm', 'd-palm', 'd-palm'],
    flowers: [], rocks: ['d-rock', 'd-rock'], grass: 'd-grass',
    celestial: 'd-sun', cloudColor: 'rgba(255,240,220,0.65)',
    particle: { type: 'sand', color: '#F5DEB3' },
    hillsFar: '#FFCC80', hillsNear: '#FF9800',
    patchColors: ['rgba(255,220,160,0.32)', 'rgba(120,80,0,0.18)', 'rgba(255,240,200,0.22)'],
  },
  {
    id: 'crystal', name: 'غار بلورین',
    skyTop: '#311B92', skyMid: '#4527A0', skyBottom: '#673AB7',
    groundTop: '#5E35B1', groundMid: '#311B92', groundBottom: '#1A0040',
    trees: ['d-blossom', 'd-blossom', 'd-blossom'],
    flowers: ['d-flower-purple'],
    rocks: ['d-rock', 'd-mushroom'], grass: 'd-grass',
    celestial: 'd-moon', cloudColor: 'rgba(180,160,255,0.35)',
    particle: { type: 'sparkle', color: '#CE93D8' },
    hillsFar: '#7E57C2', hillsNear: '#4527A0',
    patchColors: ['rgba(180,140,230,0.28)', 'rgba(20,0,50,0.22)', 'rgba(220,190,255,0.18)'],
  },
];

/* ============================================================ */
/* HELPERS */
/* ============================================================ */
const normGrade = (g) => { if (!g) return null; try { return normalizeGradeId(g) || String(g); } catch { return String(g); } };
const normField = (f) => { if (!f) return null; try { return normalizeFieldId(f) || String(f); } catch { return String(f); } };
const gradeTitle = (g) => { const id = normGrade(g); return id ? (getGrade(id)?.title || id) : ''; };
const toFa = (n) => String(n ?? '').replace(/[0-9]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[+d]);
const isAvatarPath = (a) => {
  if (!a || typeof a !== 'string') return false;
  return a.startsWith('/') || a.startsWith('http://') || a.startsWith('https://') || a.startsWith('data:');
};
const getStarsFromScore = (s) => { if (s >= 18) return 3; if (s >= 15) return 2; if (s >= 10) return 1; return 0; };

const computePositions = (n, mapHeight) => {
  if (n === 0) return [];
  if (n === 1) return [{ x: 50, y: 50 }];
  const topPad = 55;   // فاصله‌ی ثابت پیکسلی بالای آخرین گره
  const botPad = 45;   // فاصله‌ی ثابت پیکسلی زیر اولین گره
  const out = [];
  for (let i = 0; i < n; i++) {
    const yPx = topPad + (mapHeight - topPad - botPad) * (1 - i / (n - 1));
    const yPct = (yPx / mapHeight) * 100;
    let x;
    if (i === 0) x = 24;
    else if (i === n - 1) x = 50;
    else {
      const dir = i % 2 === 1 ? 1 : -1;
      const amp = 24 + 4 * Math.sin(i * 0.7);
      const drift = 3 * Math.sin(i * 1.9);
      x = Math.max(16, Math.min(84, 50 + dir * amp + drift));
    }
    out.push({ x, y: yPct });
  }
  return out;
};

const buildPathD = (positions, from, to, height) => {
  if (from >= to || to >= positions.length) return '';
  const c = positions.map((p) => ({ x: (p.x / 100) * 390, y: (p.y / 100) * height }));
  let d = `M ${c[from].x.toFixed(1)} ${c[from].y.toFixed(1)}`;
  for (let i = from; i < to; i++) {
    const p1 = c[i], p2 = c[i + 1];
    const my = (p1.y + p2.y) / 2;
    d += ` C ${p1.x.toFixed(1)} ${my.toFixed(1)}, ${p2.x.toFixed(1)} ${my.toFixed(1)}, ${p2.x.toFixed(1)} ${p2.y.toFixed(1)}`;
  }
  return d;
};

const buildBiomeGradient = (n, positions, mapHeight) => {
  const totalH = PAD_TOP + mapHeight + PAD_BOTTOM;
  const toAreaY = (my) => ((PAD_TOP + (my / 100) * mapHeight) / totalH) * 100;
  if (!n || !positions?.length) {
    const b = BIOMES[0];
    return `linear-gradient(to bottom, ${b.skyTop} 0%, ${b.skyMid} 8%, ${b.skyBottom} 16%, ${b.groundTop} 55%, ${b.groundMid} 75%, ${b.groundBottom} 100%)`;
  }
  const numBiomes = Math.ceil(n / BIOME_SIZE);
  const topBiome = BIOMES[(numBiomes - 1) % BIOMES.length];
  const stops = [
    { pos: 0, color: topBiome.skyTop },
    { pos: toAreaY(-8) * 0 + (PAD_TOP / totalH) * 50, color: topBiome.skyMid },
    { pos: toAreaY(4), color: topBiome.skyBottom },
  ];
  for (let b = numBiomes - 1; b >= 0; b--) {
    const biome = BIOMES[b % BIOMES.length];
    const topIdx = Math.min((b + 1) * BIOME_SIZE - 1, n - 1);
    const botIdx = b * BIOME_SIZE;
    const topY = positions[topIdx]?.y ?? 90;
    const botY = positions[botIdx]?.y ?? 90;
    const midY = (topY + botY) / 2;
    stops.push({ pos: toAreaY(midY), color: biome.groundTop });
    if (b === 0) {
      stops.push({ pos: toAreaY(80), color: biome.groundMid });
      stops.push({ pos: toAreaY(96), color: biome.groundBottom });
      stops.push({ pos: 100, color: biome.groundBottom });
    }
  }
  stops.sort((a, b) => a.pos - b.pos);
  return `linear-gradient(to bottom, ${stops.map((s) => `${s.color} ${s.pos.toFixed(2)}%`).join(', ')})`;
};

/* کوهان افق — پروفایل ناهموار برای دورترین لایه */
const makeMountainPath = (width, height, peaks, seed) => {
  const seg = peaks * 2 + 1;
  const pts = [];
  for (let i = 0; i < seg; i++) {
    const x = (width / (seg - 1)) * i;
    let y;
    if (i % 2 === 1) {
      y = 15 + Math.abs(Math.sin(i * 1.3 + seed) * 25 + Math.cos(i * 2.7 + seed) * 20);
    } else {
      y = 90 + Math.sin(i * 1.1 + seed) * 8 + Math.cos(i * 3.1 + seed) * 5;
    }
    y += Math.sin(i * 5.3 + seed * 3) * 3;
    pts.push({ x, y });
  }
  let d = `M 0 ${height} L 0 ${pts[0].y.toFixed(1)}`;
  for (let i = 1; i < pts.length; i++) d += ` L ${pts[i].x.toFixed(1)} ${pts[i].y.toFixed(1)}`;
  d += ` L ${width} ${height} Z`;
  return d;
};

/* تپه‌های نرم — نزدیک‌تر، گردتر */
const makeHillPath = (width, height, bumps, seed) => {
  const seg = bumps * 8;
  const pts = [];
  for (let i = 0; i <= seg; i++) {
    const t = i / seg;
    const x = width * t;
    const y = 60 + Math.sin(t * Math.PI * bumps * 2 + seed) * 20
                  + Math.sin(t * Math.PI * bumps * 0.7 + seed * 1.3) * 15;
    pts.push({ x, y });
  }
  let d = `M 0 ${height} L ${pts[0].x.toFixed(1)} ${pts[0].y.toFixed(1)}`;
  for (let i = 1; i < pts.length; i++) {
    const p = pts[i - 1], c = pts[i];
    const mx = (p.x + c.x) / 2, my = (p.y + c.y) / 2;
    d += ` Q ${p.x.toFixed(1)} ${p.y.toFixed(1)}, ${mx.toFixed(1)} ${my.toFixed(1)}`;
  }
  d += ` L ${width} ${pts[pts.length - 1].y.toFixed(1)} L ${width} ${height} Z`;
  return d;
};

const generateDecorations = (n, positions) => {
  if (!n || !positions?.length) return [];
  const decos = [];
  let uid = 0;
  const nextId = () => `d${uid++}`;
  const numBiomes = Math.ceil(n / BIOME_SIZE);
  for (let b = 0; b < numBiomes; b++) {
    const biome = BIOMES[b % BIOMES.length];
    const botIdx = b * BIOME_SIZE;
    const topIdx = Math.min((b + 1) * BIOME_SIZE - 1, n - 1);
    const botY = positions[botIdx]?.y ?? 92;
    const topY = positions[topIdx]?.y ?? (botY - 8);
    const rangeY = Math.max(4, botY - topY);
    decos.push({ id: nextId(), type: biome.trees[0], x: 12, y: topY + rangeY * 0.15, size: 30, depth: 0 });
    decos.push({ id: nextId(), type: biome.trees[1], x: 88, y: topY + rangeY * 0.28, size: 32, depth: 0 });
    decos.push({ id: nextId(), type: biome.trees[2] || biome.trees[0], x: 6, y: topY + rangeY * 0.72, size: 28, depth: 0 });
    decos.push({ id: nextId(), type: biome.trees[3] || biome.trees[0], x: 92, y: topY + rangeY * 0.82, size: 28, depth: 0 });
    decos.push({ id: nextId(), type: biome.trees[0], x: 8, y: topY + rangeY * 0.42, size: 36, depth: 1 });
    decos.push({ id: nextId(), type: biome.trees[1] || biome.trees[0], x: 94, y: topY + rangeY * 0.55, size: 34, depth: 1 });
    decos.push({ id: nextId(), type: 'd-bush', x: 20, y: topY + rangeY * 0.88, size: 18, depth: 2 });
    decos.push({ id: nextId(), type: 'd-bush', x: 80, y: topY + rangeY * 0.48, size: 16, depth: 2 });
    if (biome.flowers.length > 0) {
      decos.push({ id: nextId(), type: biome.flowers[0], x: 30, y: topY + rangeY * 0.55, size: 13, depth: 2 });
      decos.push({ id: nextId(), type: biome.flowers[1] || biome.flowers[0], x: 70, y: topY + rangeY * 0.72, size: 12, depth: 2 });
      decos.push({ id: nextId(), type: biome.flowers[2] || biome.flowers[0], x: 15, y: topY + rangeY * 0.78, size: 14, depth: 2 });
      decos.push({ id: nextId(), type: biome.flowers[3] || biome.flowers[0], x: 85, y: topY + rangeY * 0.35, size: 13, depth: 2 });
    }
    decos.push({ id: nextId(), type: biome.rocks[0], x: 25, y: topY + rangeY * 0.25, size: 15, depth: 2 });
    if (biome.rocks[1]) decos.push({ id: nextId(), type: biome.rocks[1], x: 75, y: topY + rangeY * 0.9, size: 11, depth: 2 });
    const grassPositions = [
      [10, 0.35], [22, 0.65], [35, 0.15], [45, 0.85], [55, 0.45],
      [65, 0.75], [78, 0.25], [85, 0.65], [92, 0.95], [16, 0.05],
    ];
    grassPositions.forEach(([gx, gy]) => {
      decos.push({ id: nextId(), type: biome.grass, x: gx, y: topY + rangeY * gy, size: 11, depth: 3 });
    });
  }
  return decos;
};

/* لکه‌های رنگی زمین — برای تنوع و واقعی‌تر شدن هر زیست‌بوم */
const generatePatches = (n, positions, mapHeight) => {
  if (!n || !positions?.length) return [];
  const patches = [];
  const numBiomes = Math.ceil(n / BIOME_SIZE);
  for (let b = 0; b < numBiomes; b++) {
    const biome = BIOMES[b % BIOMES.length];
    const topIdx = Math.min((b + 1) * BIOME_SIZE - 1, n - 1);
    const botIdx = b * BIOME_SIZE;
    const topY = positions[topIdx]?.y ?? 92;
    const botY = positions[botIdx]?.y ?? 92;
    const topPx = (topY / 100) * mapHeight;
    const botPx = (botY / 100) * mapHeight;
    const range = Math.max(30, botPx - topPx);
    for (let i = 0; i < 4; i++) {
      const seed = b * 13 + i * 7 + 3;
      const x = 15 + ((seed * 37) % 70); // درصد عرض
      const y = topPx + ((seed * 53) % range); // پیکسل
      const w = 25 + (seed * 11) % 35; // درصد عرض
      const h = 18 + (seed * 13) % 28; // پیکسل
      const color = biome.patchColors[i % biome.patchColors.length];
      patches.push({ key: `p-${b}-${i}`, x, y, w, h, color });
    }
  }
  return patches;
};

const DecoItem = ({ type, size }) => {
  const sizes = {
    'd-pine': [40, 60], 'd-round': [60, 60], 'd-autumn': [60, 60],
    'd-winter': [40, 60], 'd-blossom': [60, 60], 'd-palm': [50, 60],
    'd-bush': [40, 30],
    'd-flower-red': [20, 30], 'd-flower-purple': [20, 30],
    'd-flower-yellow': [20, 30], 'd-sunflower': [30, 50],
    'd-rock': [30, 22], 'd-mushroom': [20, 22],
    'd-grass': [24, 16], 'd-grass-tall': [28, 22],
  };
  const [w, h] = sizes[type] || [30, 30];
  const scale = size / 30;
  return (
    <svg width={w * scale} height={h * scale} style={{ display: 'block' }} aria-hidden="true">
      <use href={`#${type}`} />
    </svg>
  );
};

/* ============================================================ */
/* COMPONENT */
/* ============================================================ */
const ChallengeArena = () => {
  const { exams, getStudentResult } = useExams();
  const { user } = useAuth();
  const { coins, xp } = useCoins();
  const navigate = useNavigate();
  const currentUserId = user?.id;

  const scrollRef = useRef(null);
  const bookListRef = useRef(null);
  const hasScrolledRef = useRef(false);
  const [shakingId, setShakingId] = useState(null);

  /* ---------- THEME ---------- */
  const [isDarkMode, setIsDarkMode] = useState(() => {
    try { return localStorage.getItem('navbar2-drawer-dark') === '1'; } catch { return false; }
  });
  useEffect(() => {
    const onStorage = (e) => { if (e.key === 'navbar2-drawer-dark') setIsDarkMode(e.newValue === '1'); };
    window.addEventListener('storage', onStorage);
    const id = setInterval(() => {
      try { const c = localStorage.getItem('navbar2-drawer-dark') === '1'; setIsDarkMode((p) => (p !== c ? c : p)); } catch {}
    }, 500);
    return () => { window.removeEventListener('storage', onStorage); clearInterval(id); };
  }, []);

  /* ---------- GRADE / FIELD ---------- */
  const [userGrade, setUserGrade] = useState(null);
  const [userField, setUserField] = useState(null);
  const [showGradeSelector, setShowGradeSelector] = useState(false);

  useEffect(() => {
    if (!user?.id) return;
    let g = user.grade || user.class || null;
    let f = user.field || null;
    if (!g) { try { g = localStorage.getItem(`user-grade-${user.id}`); } catch {} }
    if (!f) { try { f = localStorage.getItem(`user-field-${user.id}`); } catch {} }
    const nG = normGrade(g); const nF = normField(f);
    if (nG) { setUserGrade(nG); setShowGradeSelector(false); if (nF) setUserField(nF); }
    else setShowGradeSelector(true);
  }, [user]);

  const handleGradeSelect = async (grade, field = null) => {
    const nG = normGrade(grade); const nF = field ? normField(field) : null;
    setUserGrade(nG); setShowGradeSelector(false);
    if (user?.id) {
      try {
        localStorage.setItem(`user-grade-${user.id}`, nG);
        if (nF) { localStorage.setItem(`user-field-${user.id}`, nF); setUserField(nF); }
        else { localStorage.removeItem(`user-field-${user.id}`); setUserField(null); }
      } catch {}
      try {
        await fetch(`http://localhost:3001/users/${user.id}`, {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ grade: nG, ...(nF ? { field: nF } : {}) }),
        });
      } catch (e) { console.warn('⚠️ ذخیرهٔ پایه در سرور ناموفق:', e); }
    } else setUserField(nF);
  };

  /* ---------- STREAK ---------- */
  const [streak, setStreak] = useState(() => {
    if (!user?.id) return 0;
    try {
      const raw = localStorage.getItem(`streak-${user.id}`);
      if (!raw) return 0;
      const d = JSON.parse(raw);
      const t = new Date().toISOString().split('T')[0];
      const y = new Date(Date.now() - 86400000).toISOString().split('T')[0];
      if (d?.lastActivityDate === t || d?.lastActivityDate === y) return d.streak || 0;
    } catch {}
    return 0;
  });

  /* ---------- NOW / TODAY ---------- */
  const [now, setNow] = useState(() => new Date());
  useEffect(() => { const id = setInterval(() => setNow(new Date()), 30000); return () => clearInterval(id); }, []);
  const todayStr = useMemo(() => {
    const d = now;
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }, [now]);

  /* ---------- DATA ---------- */
  const allChallenges = useMemo(() => exams.filter((e) => e.isChallenge === true && e.statusType !== 'archived'), [exams]);
  const userChallenges = useMemo(() => {
    if (!userGrade) return [];
    const needsF = needsField(userGrade);
    return allChallenges.filter((exam) => {
      if (normGrade(exam.grade) !== normGrade(userGrade)) return false;
      if (needsF) return normField(exam.field) === normField(userField);
      return true;
    });
  }, [allChallenges, userGrade, userField]);

  const bookGroups = useMemo(() => {
    const map = new Map();
    userChallenges.forEach((exam) => {
      if (!exam.book) return;
      if (!map.has(exam.book)) map.set(exam.book, []);
      map.get(exam.book).push(exam);
    });
    const out = [];
    map.forEach((arr, book) => {
      const sorted = [...arr].sort((a, b) => {
        const aCh = parseInt(String(a.chapter || '').replace(/\D/g, '')) || 0;
        const bCh = parseInt(String(b.chapter || '').replace(/\D/g, '')) || 0;
        return aCh - bCh;
      });
      const doneCount = sorted.filter((e) => {
        const r = getStudentResult(e.id, currentUserId);
        return r && r.isFinalSubmit === true;
      }).length;
      out.push({ book, exams: sorted, doneCount, total: sorted.length });
    });
    return out.sort((a, b) => a.book.localeCompare(b.book));
  }, [userChallenges, currentUserId, getStudentResult]);

  /* ---------- STREAK EFFECT ---------- */
  useEffect(() => {
    if (!currentUserId) return;
    const key = `streak-${currentUserId}`;
    let data;
    try {
      const p = JSON.parse(localStorage.getItem(key) || 'null');
      data = (p && typeof p === 'object') ? p : { lastActivityDate: null, streak: 0 };
    } catch { data = { lastActivityDate: null, streak: 0 }; }
    const hasToday = userChallenges.some((e) => {
      const r = getStudentResult(e.id, currentUserId);
      if (!r?.submittedAt) return false;
      return new Date(r.submittedAt).toISOString().split('T')[0] === todayStr;
    });
    if (hasToday) {
      if (data.lastActivityDate === todayStr) return;
      const y = new Date(Date.now() - 86400000).toISOString().split('T')[0];
      data.streak = data.lastActivityDate === y ? (data.streak || 0) + 1 : 1;
      data.lastActivityDate = todayStr;
      try { localStorage.setItem(key, JSON.stringify(data)); } catch {}
      setStreak(data.streak);
    }
  }, [userChallenges, currentUserId, getStudentResult, todayStr]);

  /* ---------- ACTIVE BOOK ---------- */
  const [activeBook, setActiveBook] = useState(null);
  useEffect(() => {
    if (bookGroups.length === 0) return;
    setActiveBook((prev) => {
      if (prev && bookGroups.find((b) => b.book === prev)) return prev;
      let stored = null;
      try { stored = localStorage.getItem(`challenge-active-book-${user?.id}`); } catch {}
      return (bookGroups.find((b) => b.book === stored) || bookGroups[0]).book;
    });
  }, [bookGroups, user?.id]);
  useEffect(() => {
    if (!activeBook || !user?.id) return;
    try { localStorage.setItem(`challenge-active-book-${user.id}`, activeBook); } catch {}
  }, [activeBook, user?.id]);

  /* ---------- CURRENT BOOK ---------- */
  const currentBookData = useMemo(() => {
    if (!activeBook) return null;
    const book = bookGroups.find((b) => b.book === activeBook);
    if (!book) return null;
    const n = book.exams.length;
    const steps = book.exams.map((exam, i) => {
      const r = getStudentResult(exam.id, currentUserId);
      const isCompleted = r && r.isFinalSubmit === true;
      const isInProgress = r && r.isFinalSubmit !== true && r?.isEssayGraded === false;
      const userScore = r ? toNumber(r.score, 0) : 0;
      const stars = isCompleted ? getStarsFromScore(userScore) : 0;
      const isPerfect = isCompleted && userScore === 20;
      const isPassed = isCompleted && userScore >= 10;
      const isCastle = i === n - 1;
      const prevR = i > 0 ? getStudentResult(book.exams[i - 1].id, currentUserId) : null;
      const prevDone = i === 0 || (prevR && prevR.isFinalSubmit === true);
      const canClick = isCompleted || isInProgress || prevDone;
      // شناسهٔ آیکون SVG به جای ایموجی
      const iconId = isCastle ? 'i-castle' : REGULAR_ICONS[i % REGULAR_ICONS.length];
      return { exam, index: i, isCompleted, isInProgress, isPassed, isPerfect, userScore, stars, iconId, isCastle, canClick };
    });
    let ci = steps.findIndex((s) => s.isInProgress);
    if (ci === -1) ci = steps.findIndex((s) => !s.isCompleted && s.canClick);
    if (ci === -1) ci = steps.length - 1;
    return { ...book, steps, currentIndex: ci };
  }, [bookGroups, activeBook, currentUserId, getStudentResult]);

  /* ---------- MAP GEOMETRY ---------- */
  const mapData = useMemo(() => {
    if (!currentBookData) return null;
    const n = currentBookData.steps.length;
    if (n === 0) return null;
    const mapHeight = Math.max(620, 110 + n * 88);
    const positions = computePositions(n, mapHeight);
    const ci = currentBookData.currentIndex;
    const biomeOf = (idx) => BIOMES[Math.floor(idx / BIOME_SIZE) % BIOMES.length];
    const totalH = PAD_TOP + mapHeight + PAD_BOTTOM;
    const horizonPct = ((PAD_TOP + 0.04 * mapHeight) / totalH) * 100;
    const topBiome = biomeOf(n - 1);
    return {
      mapHeight, positions, currentIndex: ci,
      basePath: buildPathD(positions, 0, n - 1, mapHeight),
      donePath: ci > 0 ? buildPathD(positions, 0, ci, mapHeight) : '',
      futurePath: ci < n - 1 ? buildPathD(positions, ci, n - 1, mapHeight) : '',
      biomeGradient: buildBiomeGradient(n, positions, mapHeight),
      decorations: generateDecorations(n, positions),
      patches: generatePatches(n, positions, mapHeight),
      topBiome,
      currentBiome: biomeOf(ci),
      horizonPct,
      farMountainD: makeMountainPath(390, 140, 5, 0),
      nearHillD: makeHillPath(390, 100, 4, 2.1),
      n,
    };
  }, [currentBookData]);

  /* ---------- SCROLL ---------- */
  useEffect(() => {
    if (!bookListRef.current || !activeBook) return;
    const a = bookListRef.current.querySelector('.floatBookChip.active');
    if (a) a.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }, [activeBook]);

  const scrollToCurrent = (behavior = 'smooth') => {
    const scroll = scrollRef.current;
    if (!scroll) return;
    const node = scroll.querySelector('.mapNode.current');
    if (!node) { scroll.scrollTo({ top: 0, behavior }); return; }
    const nR = node.getBoundingClientRect();
    const sR = scroll.getBoundingClientRect();
    const target = scroll.scrollTop + (nR.top - sR.top) - (scroll.clientHeight / 2) + (nR.height / 2);
    scroll.scrollTo({ top: Math.max(0, target), behavior });
  };

  useEffect(() => {
    if (!mapData) return;
    const t = setTimeout(() => {
      scrollToCurrent(hasScrolledRef.current ? 'smooth' : 'auto');
      hasScrolledRef.current = true;
    }, 300);
    return () => clearTimeout(t);
  }, [activeBook, mapData?.currentIndex, mapData?.mapHeight]);

  /* ---------- NODE CLICK ---------- */
  const handleNodeClick = (step) => {
    if (step.canClick) navigate(`/exams/take/${step.exam.id}`);
    else {
      setShakingId(step.exam.id);
      setTimeout(() => setShakingId(null), 400);
    }
  };

  /* ---------- HINT TOAST ---------- */
  const [showHint, setShowHint] = useState(() => {
    try { return !localStorage.getItem(`challenge-hint-${user?.id}`); } catch { return true; }
  });
  useEffect(() => {
    if (!showHint) return;
    const t = setTimeout(() => {
      setShowHint(false);
      try { localStorage.setItem(`challenge-hint-${user?.id}`, '1'); } catch {}
    }, 4500);
    return () => clearTimeout(t);
  }, [showHint, user?.id]);

  const selectedAvatar = (user?.avatar && String(user.avatar).trim()) || '/avatars/avatar34.png';

  /* ---------- GRADE SELECTOR ---------- */
  if (showGradeSelector) {
    const gradeSet = new Set();
    allChallenges.forEach((e) => { const id = normGrade(e.grade); if (id) gradeSet.add(id); });
    const availableGrades = [...gradeSet].sort((a, b) => (parseInt(a, 10) || 0) - (parseInt(b, 10) || 0));
    return (
      <div className={`challengeArena ${isDarkMode ? 'dark-theme' : 'light-theme'}`}>
        <div className="gradePage">
          <div className="gradeCard">
            <div className="gradeIcon">🎯</div>
            <h2>پایه تحصیلی خود را انتخاب کنید</h2>
            <p>برای مشاهدهٔ نقشهٔ ماجراجویی خود، یکی از گزینه‌های زیر را انتخاب کنید.</p>
            <div className="gradeGrid">
              {availableGrades.length === 0 ? (
                <div className="gradeEmpty">
                  <span>📭</span>
                  <p>هیچ چالشی برای نمایش وجود ندارد.</p>
                  <button className="gradeRefresh" onClick={() => window.location.reload()}>🔄 بررسی مجدد</button>
                </div>
              ) : availableGrades.map((grade) => {
                const needsF = needsField(grade);
                const meta = getGrade(grade);
                if (needsF) {
                  return (
                    <div key={grade} className="gradeFieldBlock">
                      <div className="gradeFieldTitle">{meta?.title || grade}</div>
                      <div className="gradeFieldRow">
                        {getFieldOptions(grade, { includeEmpty: false }).map((f) => (
                          <button key={f.value} className="gradeFieldBtn" onClick={() => handleGradeSelect(grade, f.value)}>{f.label}</button>
                        ))}
                      </div>
                    </div>
                  );
                }
                return <button key={grade} className="gradeBtn" onClick={() => handleGradeSelect(grade, null)}>{gradeTitle(grade)}</button>;
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (userGrade && bookGroups.length === 0) {
    return (
      <div className={`challengeArena ${isDarkMode ? 'dark-theme' : 'light-theme'}`}>
        <div className="gradePage">
          <div className="gradeCard">
            <div className="gradeIcon">📭</div>
            <h2>هیچ چالشی برای پایهٔ {gradeTitle(userGrade)} وجود ندارد</h2>
            <p>هنوز چالشی برای پایهٔ تحصیلی شما تعریف نشده است.</p>
            <button className="gradeRefresh" onClick={() => { setShowGradeSelector(true); setUserGrade(null); }}>🔄 انتخاب پایهٔ دیگر</button>
          </div>
        </div>
      </div>
    );
  }

  /* ---------- PARTICLE COUNT ---------- */
  const particleCount = 26;

  /* ============================================================ */
  /* MAIN RENDER */
  /* ============================================================ */
  return (
    <div className={`challengeArena ${isDarkMode ? 'dark-theme' : 'light-theme'}`}>
      <DecoSprites />
      <StageIconSprites />

      <button className="floatBack" onClick={() => navigate(-1)} aria-label="بازگشت">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>

      <div className="floatStats">
        <div className="floatPill xp">
          <span className="pillIcon">⚡</span>
          <span className="pillVal">{toFa(xp.toLocaleString())}</span>
        </div>
        <div className="floatPill coins">
          <span className="pillIcon">🪙</span>
          <span className="pillVal">{toFa(coins.toLocaleString())}</span>
        </div>
      </div>

      {showHint && <div className="hintToast">👆 برای شروع، روی مرحلهٔ فعلی ضربه بزن</div>}

      {/* لایهٔ ذرات محیطی */}
      {mapData && (
        <div className="particleLayer" aria-hidden="true">
          {Array.from({ length: particleCount }).map((_, i) => (
            <span
              key={i}
              className={`particle particle-${mapData.currentBiome.particle.type}`}
              style={{
                left: `${(i * 37 + 11) % 100}%`,
                animationDelay: `${((i * 0.53) % 8).toFixed(2)}s`,
                animationDuration: `${(7 + (i % 5) * 1.6).toFixed(2)}s`,
                '--drift': `${((i % 3) - 1) * (25 + (i % 25))}px`,
                '--color': mapData.currentBiome.particle.color,
                '--size': `${4 + (i % 3) * 2}px`,
              }}
            />
          ))}
        </div>
      )}

      <main className="mapScroll" ref={scrollRef}>
        {currentBookData && mapData ? (
          <div className="mapArea" style={{ background: mapData.biomeGradient }}>
            {/* ===== کوهان افق (لایهٔ جدید) ===== */}
            <div className="horizonMountains" style={{ top: `${mapData.horizonPct}%` }} aria-hidden="true">
              <svg viewBox="0 0 390 140" preserveAspectRatio="none">
                <path d={mapData.farMountainD} fill={mapData.topBiome.hillsFar} opacity="0.5" />
                <path d={mapData.nearHillD} fill={mapData.topBiome.hillsNear} opacity="0.7" />
              </svg>
            </div>

            {/* ===== لکه‌های رنگی زمین (لایهٔ جدید) ===== */}
            {mapData.patches.map((p) => (
              <div
                key={p.key}
                className="biomePatch"
                style={{
                  left: `${p.x}%`,
                  top: `calc(90px + ${p.y}px)`,
                  width: `${p.w}%`,
                  height: `${p.h}px`,
                  background: `radial-gradient(ellipse at center, ${p.color} 0%, transparent 70%)`,
                }}
                aria-hidden="true"
              />
            ))}

            {/* جو: نور خورشید */}
            <div className="lightRays" />
            <div className="groundTexture" />

            {/* آسمان */}
            <div className="skyLayer" aria-hidden="true">
              <div className="sunWrap">
                <svg viewBox="0 0 80 80" width="84" height="84" style={{ display: 'block' }}>
                  <use href={`#${mapData.topBiome.celestial}`} />
                </svg>
              </div>
              <div className="cloud cloud-1">
                <svg viewBox="0 0 100 40" width="90" height="36"><use href="#d-cloud" /></svg>
              </div>
              <div className="cloud cloud-2">
                <svg viewBox="0 0 100 40" width="70" height="28"><use href="#d-cloud" /></svg>
              </div>
              <div className="cloud cloud-3">
                <svg viewBox="0 0 100 40" width="110" height="44"><use href="#d-cloud" /></svg>
              </div>
              <div className="birdLayer">
                <div className="bird bird1"><svg viewBox="0 0 24 8" width="22" height="8"><use href="#d-bird" /></svg></div>
                <div className="bird bird2"><svg viewBox="0 0 24 8" width="16" height="6"><use href="#d-bird" /></svg></div>
                <div className="bird bird3"><svg viewBox="0 0 24 8" width="14" height="5"><use href="#d-bird" /></svg></div>
              </div>
            </div>

            <div className="mapContent" style={{ height: `${mapData.mapHeight}px` }}>
              {/* مسیرهای SVG */}
              <svg viewBox={`0 0 390 ${mapData.mapHeight}`} preserveAspectRatio="xMidYMid meet" className="mapSvg" aria-hidden="true">
                <defs>
                  <linearGradient id="pathGradDone" x1="0" y1={mapData.mapHeight} x2="0" y2="0" gradientUnits="userSpaceOnUse">
                    <stop offset="0%" stopColor="#a78bfa" />
                    <stop offset="50%" stopColor="#8b5cf6" />
                    <stop offset="100%" stopColor="#64b5ff" />
                  </linearGradient>
                  <filter id="pathGlow" x="-50%" y="-50%" width="200%" height="200%">
                    <feGaussianBlur stdDeviation="3" result="b" />
                    <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
                  </filter>
                  <filter id="pathShadow">
                    <feGaussianBlur stdDeviation="3.5" />
                  </filter>
                </defs>

                {mapData.basePath && (
                  <path d={mapData.basePath} fill="none" stroke="rgba(0,0,0,0.45)" strokeWidth="26" strokeLinecap="round" strokeLinejoin="round" filter="url(#pathShadow)" />
                )}
                {mapData.basePath && (
                  <path d={mapData.basePath} fill="none" stroke="#7a5f3b" strokeWidth="22" strokeLinecap="round" strokeLinejoin="round" />
                )}
                {mapData.basePath && (
                  <path d={mapData.basePath} fill="none" stroke="#b8956a" strokeWidth="17" strokeLinecap="round" strokeLinejoin="round" />
                )}
                {mapData.basePath && (
                  <path d={mapData.basePath} fill="none" stroke="#a08052" strokeWidth="17" strokeDasharray="2 12" strokeLinecap="round" strokeLinejoin="round" opacity="0.55" />
                )}
                {mapData.basePath && (
                  <path d={mapData.basePath} fill="none" stroke="rgba(255,235,200,0.4)" strokeWidth="1.5" strokeDasharray="4 22" strokeLinecap="round" opacity="0.8" />
                )}
                {mapData.donePath && (
                  <path d={mapData.donePath} fill="none" stroke="url(#pathGradDone)" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" filter="url(#pathGlow)" opacity="0.95" />
                )}
                {mapData.donePath && (
                  <path d={mapData.donePath} fill="none" stroke="rgba(255,255,255,0.85)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="2 8" />
                )}
                {mapData.futurePath && (
                  <path d={mapData.futurePath} fill="none" stroke="rgba(255,255,255,0.55)" strokeWidth="2.6" strokeDasharray="7 9" strokeLinecap="round" strokeLinejoin="round" />
                )}
              </svg>

              {/* دکوراسیون */}
              {mapData.decorations.map((d) => (
                <div key={d.id} className={`mapDeco depth${d.depth}`} style={{ left: `${d.x}%`, top: `${d.y}%` }} aria-hidden="true">
                  <DecoItem type={d.type} size={d.size} />
                </div>
              ))}

              {/* پروانه‌ها */}
              <div className="butterfly b1"><svg viewBox="0 0 20 16" width="14" height="11"><use href="#d-butterfly" /></svg></div>
              <div className="butterfly b2"><svg viewBox="0 0 20 16" width="12" height="10"><use href="#d-butterfly" /></svg></div>
              <div className="butterfly b3"><svg viewBox="0 0 20 16" width="10" height="8"><use href="#d-butterfly" /></svg></div>

              <div className="mapCompass">🧭</div>

              {/* گره‌ها */}
              {currentBookData.steps.map((step, i) => {
                const pos = mapData.positions[i];
                const isCurrent = i === mapData.currentIndex && !step.isCompleted;
                let statusClass;
                if (step.isCompleted) {
                  if (step.isPerfect) statusClass = 'perfect';
                  else if (step.isPassed) statusClass = 'done';
                  else statusClass = 'failed';
                } else if (isCurrent) statusClass = 'current';
                else statusClass = 'locked';

                return (
                  <button
                    key={step.exam.id}
                    type="button"
                    className={`mapNode ${statusClass} ${step.isCastle ? 'castle' : ''} ${shakingId === step.exam.id ? 'shake' : ''}`}
                    style={{ left: `${pos.x}%`, top: `${pos.y}%` }}
                    onClick={() => handleNodeClick(step)}
                    aria-label={step.exam.title}
                  >
                    {isCurrent && <span className="youHere">شما اینجا</span>}
                    {step.isCastle && <span className="nodeCrown">👑</span>}
<span className="nodeStars">
  {[1, 2, 3].map((n) => <span key={n} className={n <= step.stars ? 'on' : 'off'}>★</span>)}
</span>
                    <span className="nodeCircle">
                      <span className="nodeShine" aria-hidden="true" />
                      {isCurrent
                        ? (isAvatarPath(selectedAvatar)
                            ? <span className="nodeAvatarImg" style={{ backgroundImage: `url("${selectedAvatar}")` }} />
                            : <span className="nodeAvatarEmoji">{selectedAvatar}</span>)
                        : (
                          <span className="nodeIcon">
                            <svg viewBox="0 0 48 48" aria-hidden="true">
                              <use href={`#${step.iconId}`} />
                            </svg>
                          </span>
                        )}
                    </span>
                    <span className="nodeLabel">{step.exam.title}</span>
                  </button>
                );
              })}
            </div>
          </div>
        ) : null}
      </main>

      {bookGroups.length > 0 && (
        <div className="floatBooks">
          <div className="floatBooksInner" ref={bookListRef}>
            {bookGroups.map((b) => (
              <button
                key={b.book}
                className={`floatBookChip ${activeBook === b.book ? 'active' : ''}`}
                onClick={() => setActiveBook(b.book)}
              >
                <span>{b.book}</span>
                <span className="floatBookCount">{toFa(b.doneCount)}/{toFa(b.total)}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChallengeArena;